import { ApiClientError } from '../../../shared/api/client.js';

/**
 * O'tish XATOLARI — to'rt xil javob, to'rt xil ma'no.
 *
 * Farqi foydalanuvchi uchun muhim, chunki keyingi qadam har xil:
 *   - `guard` (400) — shart bajarilmagan (satr yo'q, sabab yo'q, rasm yo'q):
 *     serverning xabari o'qiladi va tuzatiladi;
 *   - `permission` (403) — bu amal umuman bu xodimniki emas;
 *   - `missing` (404) — talabnoma yo'q yoki boshqa doirada (mavjudligi
 *     ataylab oshkor qilinmaydi);
 *   - `conflict` (409) — talabnomani boshqa xodim allaqachon qo'zg'atgan:
 *     qayta urinish EMAS, yangilash kerak;
 *   - `unknown` — qolgani (tarmoq, 500).
 */
export type TransitionFailureKind =
  | 'guard'
  | 'permission'
  | 'missing'
  | 'conflict'
  | 'unknown';

export const transitionFailureKind = (error: unknown): TransitionFailureKind => {
  if (!(error instanceof ApiClientError)) return 'unknown';
  switch (error.status) {
    case 400:
      return 'guard';
    case 403:
      return 'permission';
    case 404:
      return 'missing';
    case 409:
      return 'conflict';
    default:
      return 'unknown';
  }
};

/** Serverning xabari odam uchun yozilgan — u bor bo'lsa o'zimizniki yashirmaydi. */
export const requisitionErrorText = (error: unknown, fallback: string): string =>
  error instanceof ApiClientError ? error.message : fallback;

/** 409 dan keyin qayta urinish befoyda — kartochkani yangilash kerak. */
export const needsRefresh = (error: unknown): boolean =>
  transitionFailureKind(error) === 'conflict';
